import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsv = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.53773 12.5592C9.29309 12.5592 9.0834 12.664 8.94361 12.8388C8.80381 13.0135 8.73392 13.2931 8.73392 13.6426C8.73392 14.3765 9.0135 14.726 9.53773 14.726C9.78237 14.726 10.027 14.6561 10.3765 14.5512V15.1454C10.0969 15.2502 9.81732 15.3201 9.46783 15.3201C8.97856 15.3201 8.62907 15.1803 8.38443 14.9007C8.13979 14.6211 8 14.2018 8 13.6775C8 13.328 8.0699 13.0485 8.17474 12.8038C8.27959 12.5592 8.48928 12.3495 8.69897 12.2097C8.94361 12.0699 9.18824 12 9.50278 12C9.81732 12 10.1319 12.0699 10.4464 12.2446L10.2716 12.7689C10.1668 12.699 10.027 12.664 9.92216 12.6291C9.81732 12.5941 9.64257 12.5592 9.53773 12.5592Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0666 14.3765C13.0666 14.6561 12.9618 14.9007 12.7521 15.0755C12.5424 15.2502 12.2628 15.3201 11.8784 15.3201C11.5289 15.3201 11.2144 15.2502 10.9697 15.1104V14.4813C11.1794 14.5862 11.3891 14.6561 11.5289 14.691C11.6687 14.726 11.8085 14.7609 11.9483 14.7609C12.0881 14.7609 12.2279 14.726 12.2978 14.691C12.3677 14.6211 12.4026 14.5512 12.4026 14.4464C12.4026 14.3765 12.3677 14.3415 12.3327 14.2716C12.2978 14.2017 12.2279 14.1668 12.1929 14.1319C12.123 14.0969 11.9832 14.027 11.7735 13.9222C11.5638 13.8173 11.4241 13.7474 11.3192 13.6426C11.2144 13.5377 11.1445 13.4678 11.0746 13.328C11.0047 13.1882 10.9697 13.0834 10.9697 12.9087C10.9697 12.6291 11.0746 12.3844 11.2493 12.2446C11.459 12.0699 11.7036 12 12.0531 12C12.2279 12 12.3677 12.0349 12.5424 12.0699C12.6822 12.1048 12.8569 12.1747 13.0317 12.2446L12.822 12.7689C12.6472 12.699 12.5075 12.664 12.4026 12.6291C12.2978 12.5941 12.1929 12.5941 12.0531 12.5941C11.9133 12.5941 11.8085 12.6291 11.7386 12.699C11.6687 12.7689 11.6687 12.8038 11.6687 12.9087C11.6687 12.9786 11.6687 13.0135 11.7036 13.0834C11.7386 13.1533 11.7735 13.1882 11.8434 13.2232C11.9133 13.2581 12.0531 13.328 12.2628 13.4678C12.5774 13.6076 12.787 13.7474 12.8919 13.8872C12.9967 14.027 13.0666 14.1668 13.0666 14.3765Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5826 12.0352H16.2816L15.1982 15.2854H14.4643L13.3809 12.0352H14.0798L14.6739 13.9573C14.7089 14.0622 14.7438 14.202 14.7788 14.3418C14.8137 14.4815 14.8487 14.5864 14.8487 14.6563C14.8487 14.5165 14.9186 14.2719 15.0234 13.9573L15.5826 12.0352Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0996 3V7.8H18.8996",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9 17V8.21421C18.9 7.949 18.7946 7.69464 18.6071 7.50711L14.3929 3.29289C14.2054 3.10536 13.951 3 13.6858 3H5.5C4.94771 3 4.5 3.44772 4.5 4V17",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 18.3V20C4.5 20.5523 4.94772 21 5.5 21H17.9C18.4523 21 18.9 20.5523 18.9 20V18.3",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
export default SvgCsv;
